import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

const OneTimeIcon = (props: SvgIconProps) => (
  <SvgIcon width="10" height="10" viewBox="0 0 10 10" fill={"none"} {...props}>
    <path
      d="M5 0.769231C2.66341 0.769231 0.769231 2.66341 0.769231 5C0.769231 7.33658 2.66341 9.23077 5 9.23077C7.33658 9.23077 9.23077 7.33658 9.23077 5C9.23077 2.66341 7.33658 0.769231 5 0.769231ZM0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5Z"
      fill="#004CBD"
    />
    <path
      d="M5.37377 2.54551C5.49885 2.61244 5.57693 2.74277 5.57693 2.88462V7.30769C5.57693 7.52011 5.40474 7.69231 5.19231 7.69231C4.97989 7.69231 4.8077 7.52011 4.8077 7.30769V3.60327L4.25181 3.97388C4.07508 4.09169 3.83627 4.04392 3.71843 3.86719C3.60062 3.69046 3.64839 3.45165 3.82512 3.33385L4.97897 2.5646C5.09697 2.48591 5.24874 2.47858 5.37377 2.54551Z"
      fill="#004CBD"
    />
  </SvgIcon>
);

export default OneTimeIcon;
